
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imprint",
      function () {
        return require("private-next-pages/imprint.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/imprint"])
      });
    }
  